export class AgreementEndMileageModification {
    mileageModificationType: number;
    mileageAdjustmentType: number;
    adjustByValue: number;
}


// WEBPACK FOOTER //
// ./src/app/report/models/agreement-end-mileage-modification.model.ts